module.exports = __webpack_public_path__ + "files/e79bfd3d857ac93e6cc2f79a58e6e667.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/smileys_emotion-2.png
// module id = 491
// module chunks = 76